// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".regionCriteria {\r\n\tposition: absolute;\r\n\ttop: 40px;\r\n\tleft: 0px;\r\n\theight: 65px;\r\n\tfont-size: 10px;\r\n\tz-index: +221;\r\n\twidth: 288px;\r\n\tbackground: #00000052;\r\n}\r\n\r\n.testKey {\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\tleft: 500px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
